import { Center, Stack, Text, VStack } from '@wegroup/design-system';
import React from 'react';

interface Props {
  Icon: React.ReactElement;
  title: string;
  description: React.ReactNode;
}

const ComparisonMatrixOfferHeader: React.FC<React.PropsWithChildren<Props>> = ({
  Icon,
  title,
  description,
  ...otherProps
}) => {
  return (
    <Stack
      direction={{
        base: 'row',
        laptop: 'column',
      }}
      p={{ base: '4', laptop: '0' }}
      spacing={{ base: '4', laptop: '1' }}
      {...otherProps}
    >
      <Center
        bg={{ base: 'gray.ultraLight', laptop: 'unset' }}
        borderRadius="md"
        p="2"
        maxH={{ laptop: '12' }}
        width={{ base: '20', laptop: '100%' }}
        height={{ base: '20' }}
      >
        {Icon ? Icon : title}
      </Center>
      <VStack
        align={{ base: 'flex-start', laptop: 'center' }}
        justify="center"
        spacing="0"
      >
        <Text textStyle="largeBodyBold">{title}</Text>
        <Text
          textStyle="normalBody"
          color={{ base: 'text.gray', laptop: 'black' }}
          textAlign={{ laptop: 'center' }}
        >
          {description}
        </Text>
      </VStack>
    </Stack>
  );
};

export default ComparisonMatrixOfferHeader;
